import { SeatOrgKind } from "@sx/protocol/fleet/supervision";
import { Navigate, createFileRoute } from "@tanstack/react-router";

import { FleetPage } from "../../../workspaces/fleet/pages/FleetPage";
import { useSeat } from "../../../workspaces/fleet/seat";

export const Route = createFileRoute("/_console/p/$org/$project/deploy/stations/")({
  component: StationsIndex,
});

/* Live supervision with no station chosen yet. The page picks the station that most needs
 * watching and canonicalizes into its address, exactly as the hardware registry does —
 * which is why nothing here carries a station: this address is the one that has none.
 * A teleop vendor has no fleet of its own to watch; its home is the help queue. */
function StationsIndex() {
  const seat = useSeat();
  const address = Route.useParams();
  const navigate = Route.useNavigate();
  if (seat.orgKind === SeatOrgKind.TELEOP_VENDOR) return <Navigate to="/teleoperators" replace />;
  return (
    <FleetPage
      onStationChange={(next, replace = false) =>
        void navigate({
          to: "/p/$org/$project/deploy/stations/$stationId",
          params: { ...address, stationId: next },
          replace,
        })
      }
    />
  );
}
